import React, { useState } from 'react';
import axios from 'axios';
import UserDropdown from './BeforePublicationUser'; // Ensure the path is correct

const ResearchPaperForm = () => {
  const [formData, setFormData] = useState({
    claimedId: '',
    paperTitle: '',
    journalName: '',
    status: '0',
    citations: [],
  });

  const [newCitation, setNewCitation] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);

  const handleSelectUser = (user) => {
    setSelectedUser(user);
    setFormData({ ...formData, claimedId: user?.value || '' });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAddCitation = () => {
    if (newCitation.trim() !== '') {
      setFormData({
        ...formData,
        citations: [...formData.citations, newCitation.trim()],
      });
      setNewCitation('');
    }
  };

  const handleRemoveCitation = (index) => {
    const updated = formData.citations.filter((_, i) => i !== index);
    setFormData({ ...formData, citations: updated });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.citations.length < 5) {
      alert('Please add at least 5 citation references before submitting.');
      return;
    }
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/beforepublications`, formData);
      alert('Submitted successfully!');
      setFormData({
        claimedId: '',
        paperTitle: '',
        journalName: '',
        status: '0',
        citations: [],
      });
      setNewCitation('');
      setSelectedUser(null);
    } catch (err) {
      console.error(err);
      alert('Submission failed!');
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-10 border rounded p-4 shadow bg-light">
          <h3 className="text-center mb-4 text-primary">Research Paper Submission (Before Publication)</h3>

          <form onSubmit={handleSubmit}>
            {/* Claimed ID Dropdown */}
            <div className="mb-4">
              <label className="form-label fw-bold">Claimed By (User)</label>
              <UserDropdown
                selectedUser={selectedUser}
                handleSelectUser={handleSelectUser}
              />
            </div>

            {/* Paper Title */}
            <div className="mb-4">
              <label htmlFor="paperTitle" className="form-label fw-bold">Paper Title</label>
              <input
                type="text"
                className="form-control"
                id="paperTitle"
                name="paperTitle"
                placeholder="Enter the paper title"
                value={formData.paperTitle}
                onChange={handleChange}
                required
              />
            </div>

            {/* Journal Name */}
            <div className="mb-4">
              <label htmlFor="journalName" className="form-label fw-bold">Journal Name</label>
              <input
                type="text"
                className="form-control"
                id="journalName"
                name="journalName"
                placeholder="Enter the journal name"
                value={formData.journalName}
                onChange={handleChange}
                required
              />
            </div>

            {/* Citation Input */}
            <div className="mb-4">
              <label className="form-label fw-bold">Citation Reference</label>
              <div className="row g-2 align-items-center">
                <div className="col-9">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Author, Year - Title"
                    value={newCitation}
                    onChange={(e) => setNewCitation(e.target.value)}
                  />
                </div>
                <div className="col-3 d-grid">
                  <button
                    type="button"
                    className="btn btn-sm btn-secondary"
                    style={{ height: "50px" }}
                    onClick={handleAddCitation}
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>

            {/* Citations List */}
            {formData.citations.length > 0 && (
              <div className="mb-4">
                <ul className="list-group">
                  {formData.citations.map((citation, index) => (
                    <li
                      className="list-group-item d-flex justify-content-between align-items-center"
                      key={index}
                    >
                      {citation}
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleRemoveCitation(index)}
                      >
                        Remove
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Submit Button */}
            <div className="text-center mt-4">
              <button type="submit" className="btn btn-primary px-4 py-2">
                Submit Paper
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResearchPaperForm;
